<template>
  <div>
    <b-modal id="modalEditTrafficClasses" ref="modalEditTrafficClasses" :title="$t('Traffic classes')" hide-footer size="xl">
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Class ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col cols="8">
              <b-form-input type="number" :disabled="isEdit" v-model="editItem.info.tclass_id" aria-describedby="inputFeedbackClassId" :state="editItem.info.tclass_id > 0"/>
              <b-form-invalid-feedback id="inputFeedbackClassId">
                {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-col>
            <b-col>
              <b-form-group :label="$t('Local traffic policy')">
                <b-form-select :options="localPolicyList" v-model="editItem.info.local_policy">{{ $t('Local traffic policy') }}</b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Traffic class name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col cols="8">
              <b-form-input type="text" v-model="editItem.info.name" aria-describedby="inputFeedbackName" :state="editItem.info.name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-col>
            <b-col cols="4">
              <b-form-checkbox v-model="isDontSave">{{ $t('Don`t save') }}</b-form-checkbox>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Time range')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col cols="8">
              <b-form-select :options="timeRangeList" v-model="editItem.info.timerange_id"/>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Graph color')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col cols="8">
              <b-form-input type="color" style="background: none" v-model="editItem.info.color"/>
            </b-col>
            <b-col cols="2">
              <b-form-checkbox v-model="isDisplay">{{ $t('Display') }}</b-form-checkbox>
            </b-col>
            <b-col cols="2">
              <b-form-checkbox v-model="isFillin">{{ $t('Fill in') }}</b-form-checkbox>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group :label="$t('Traffic subclasses')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-button variant="success" style="float: right" size="sm" @click="showAddSubclasses">{{ $t('Add') }}</b-button>
        </b-form-group>
        <b-table striped hover small id="tablereport" responsive
          :items="editItem.item"
          :fields="subclassesFields">
          <template v-slot:cell(isSkip)="data">
            <b-form-checkbox disabled v-model="data.value"/>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click.stop="ClickOnEditSubclassesButton(row)" id="transparent">
              <b-img :src='editImage'/>
            </b-button>
            <b-button size="sm" @click.stop="ClickOnDeleteSubclassesButton(row)" id="transparent">
              <b-img :src='deleteImage'/>
            </b-button>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalEditTrafficClasses">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>

        <b-modal hide-footer :title="$t('Subclasses details')" ref="modalSubclasses" id="modalSubclasses">
          <b-tabs pills card>
            <b-tab :title="$t('Source')">
              <b-form-group label-align="right" :label="$t('Address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="subclasses.source" placeholder="0.0.0.0"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Port')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.sport"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Interface')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.iface"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('AS')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.src_as"/>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Addressee')">
              <b-form-group label-align="right" :label="$t('Address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="subclasses.destination" placeholder="0.0.0.0"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Port')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.dport"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Interface')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.oface"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('AS')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.dst_as"/>
              </b-form-group>
            </b-tab>
            <b-tab :title="$t('Common part')">
              <b-form-group label-align="right" :label="$t('Protocol')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.proto"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Next router')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="text" v-model="subclasses.nexthop" placeholder="0.0.0.0"/>
              </b-form-group>
              <b-form-group label-align="right" label="TOS" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.tos"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('TCP flags')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input type="number" v-model="subclasses.tcp_flags"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('NetFlow provider')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select :options="netflowList" v-model="subclasses.nfprovider_id"/>
              </b-form-group>
              <b-form-group label-align="right" :label="$t('Skip')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox v-model="subclasses.isSkip"/>
              </b-form-group>
            </b-tab>
          </b-tabs>
          <b-row>
            <b-col>
              <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveSubclasses">Ok</b-button>
            </b-col>
            <b-col sm="1.5">
              <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$bvModal.hide('modalSubclasses')">{{ $t('Cancel') }}</b-button>
            </b-col>
          </b-row>
        </b-modal>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: null,
    editItem: null,
    isDisplay: null,
    isFillin: null,
    isDontSave: null,
    netflowList: null,
    flagSkip: null
  },
  data () {
    return {
      num: 1000000,
      subclasses: {
        'isSkip': false,
        'item_id': 0,
        'flags': 0,
        'nfprovider_id': 0,
        'saddr': '',
        'saddr_mask': 0,
        'daddr': '',
        'daddr_mask': 0,
        'nexthop': '',
        'from_addr': '',
        'sport': 0,
        'dport': 0,
        'tcp_flags': 0,
        'proto': 0,
        'tos': 0,
        'src_as': 0,
        'dst_as': 0,
        'iface': 0,
        'oface': 0,
        'source': '',
        'destination': ''},
      flagSrcPort: 2,
      flagDstPort: 4,
      flagTcpFlags: 8,
      flagProto: 16,
      flagTos: 32,
      flagSrcAS: 64,
      flagDstAS: 128,
      flagIFace: 256,
      flagOFace: 512,
      flagNextHop: 1024,
      flagFromAddr: 2048,
      localPolicyList: [
        {text: this.$i18n.t('To receiver'), value: 0},
        {text: this.$i18n.t('To sender'), value: 1},
        {text: this.$i18n.t('Both'), value: 2}
      ],
      subclassesFields: [
        {key: 'source', label: this.$i18n.t('Source'), sortable: true},
        {key: 'sport', label: this.$i18n.t('Src port'), sortable: true},
        {key: 'iface', label: this.$i18n.t('Incoming interface'), sortable: true},
        {key: 'src_as', label: this.$i18n.t('Src AS'), sortable: true},
        {key: 'destination', label: this.$i18n.t('Destination'), sortable: true},
        {key: 'dport', label: this.$i18n.t('Dst port'), sortable: true},
        {key: 'oface', label: this.$i18n.t('Outgoing interface'), sortable: true},
        {key: 'dst_as', label: this.$i18n.t('Dst AS'), sortable: true},
        {key: 'proto', label: this.$i18n.t('Protocol'), sortable: true},
        {key: 'tos', label: 'Tos', sortable: true},
        {key: 'nexthop', label: this.$i18n.t('Next router'), sortable: true},
        {key: 'tcp_flags', label: this.$i18n.t('TCP flags'), sortable: true},
        {key: 'isSkip', label: this.$i18n.t('Skip'), sortable: true},
        {key: 'ipNetflow', label: this.$i18n.t('Router IP'), sortable: true},
        {key: 'nfprovider_id', label: this.$i18n.t('Router ID'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    save () {
      if (!this.editItem.info.tclass_id || !this.editItem.info.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Class ID or traffic class name fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.item.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Traffic subclasses table is empty'), 'Error')
        return
      }
      let newTCClasses = {
        tclass_id: 0,
        name: '',
        color: 0,
        info_flags: 1,
        local_policy: 0,
        sub_tclasses: []
      }
      if (this.isFillin) newTCClasses.info_flags = 1
      if (this.isDisplay) newTCClasses.info_flags = 2
      if (this.isDontSave) newTCClasses.info_flags = 4
      if (this.isFillin && this.isDisplay) newTCClasses.info_flags = 3
      if (this.isFillin && this.isDontSave) newTCClasses.info_flags = 5
      if (this.isDisplay && this.isDontSave) newTCClasses.info_flags = 6
      if (this.isDisplay && this.isDontSave && this.isFillin) newTCClasses.info_flags = 7
      newTCClasses.sub_tclasses = this.editItem.item
      newTCClasses.tclass_id = Number(this.editItem.info.tclass_id)
      newTCClasses.name = this.editItem.info.name
      newTCClasses.local_policy = this.editItem.info.local_policy
      newTCClasses.color = this.editItem.info.color.substr(1, 6)
      newTCClasses.color = parseInt(newTCClasses.color, 16)
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_TRAFFIC_CLASSES', newTCClasses)
        : this.$store.dispatch('Tariffing/CREATE_TRAFFIC_CLASSES', newTCClasses)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TRAFFIC_CLASSES_LIST')
          this.$refs.modalEditTrafficClasses.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    showAddSubclasses () {
      this.subclasses = {
        num: 0,
        'isSkip': false,
        'item_id': 0,
        'flags': 0,
        'nfprovider_id': 0,
        'saddr': '',
        'saddr_mask': 0,
        'daddr': '',
        'daddr_mask': 0,
        'nexthop': '',
        'from_addr': '',
        'sport': 0,
        'dport': 0,
        'tcp_flags': 0,
        'proto': 0,
        'tos': 0,
        'src_as': 0,
        'dst_as': 0,
        'iface': 0,
        'oface': 0,
        'source': '',
        'destination': ''
      }
      this.$refs.modalSubclasses.show()
    },
    ClickOnEditSubclassesButton (row) {
      this.subclasses = row.item
      this.$refs.modalSubclasses.show()
    },
    ClickOnDeleteSubclassesButton (row) {
      this.editItem.item = this.editItem.item.filter((value) => {
        return value !== row.item
      })
    },
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.validIPaddress.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    hideModalEditTrafficClasses () {
      this.$refs.modalEditTrafficClasses.hide()
    },
    saveSubclasses () {
      if (!this.subclasses.source || !this.subclasses.destination) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Fill in the fields address'), 'Error')
        return
      }
      this.validIPaddress = this.subclasses.source.split('/')[0]
      if (!this.validationIP()) return
      this.validIPaddress = this.subclasses.destination.split('/')[0]
      if (!this.validationIP()) return
      if (this.subclasses.nexthop) {
        this.validIPaddress = this.subclasses.nexthop.split('/')[0]
        if (!this.validationIP()) return
      }

      this.subclasses.saddr = this.subclasses.source.split('/')[0]
      this.subclasses.saddr_mask = this.subclasses.source.split('/')[1]
      if (!Number(this.subclasses.saddr_mask)) {
        this.subclasses.saddr_mask = 32
      }
      this.subclasses.daddr = this.subclasses.destination.split('/')[0]
      this.subclasses.daddr_mask = this.subclasses.source.split('/')[1]
      if (!Number(this.subclasses.daddr_mask)) {
        this.subclasses.daddr_mask = 32
      }
      if (this.subclasses.nfprovider_id) {
        for (let i in this.netflowList) {
          if (this.subclasses.nfprovider_id === this.netflowList[i].id) {
            this.subclasses.from_addr = this.netflowList[i].address
            break
          }
        }
      }
      this.subclasses.dst_as = Number(this.subclasses.dst_as)
      this.subclasses.dport = Number(this.subclasses.dport)
      this.subclasses.iface = Number(this.subclasses.iface)
      this.subclasses.oface = Number(this.subclasses.oface)
      this.subclasses.proto = Number(this.subclasses.proto)
      this.subclasses.sport = Number(this.subclasses.sport)
      this.subclasses.src_as = Number(this.subclasses.src_as)
      this.subclasses.tcp_flags = Number(this.subclasses.tcp_flags)
      this.subclasses.tos = Number(this.subclasses.tos)

      this.subclasses.flags = 0
      this.subclasses.flags += this.subclasses.isSkip ? this.flagSkip : 0
      this.subclasses.flags += this.subclasses.sport ? this.flagSrcPort : 0
      this.subclasses.flags += this.subclasses.dport ? this.flagDstPort : 0
      this.subclasses.flags += this.subclasses.tcp_flags ? this.flagTcpFlags : 0
      this.subclasses.flags += this.subclasses.proto ? this.flagProto : 0
      this.subclasses.flags += this.subclasses.tos ? this.flagTos : 0
      this.subclasses.flags += this.subclasses.src_as ? this.flagSrcAS : 0
      this.subclasses.flags += this.subclasses.dst_as ? this.flagDstAS : 0
      this.subclasses.flags += this.subclasses.iface ? this.flagIFace : 0
      this.subclasses.flags += this.subclasses.oface ? this.flagOFace : 0
      this.subclasses.flags += this.subclasses.nexthop ? this.flagNextHop : 0
      this.subclasses.flags += this.subclasses.nfprovider_id ? this.flagFromAddr : 0
      if (this.subclasses.num > 0) {
        for (let el of this.editItem.item) {
          if (el.num === this.subclasses.num) {
            el = this.subclasses
          }
        }
      } else {
        this.subclasses.num = ++this.num
        this.editItem.item.push(this.subclasses)
      }
      this.$refs.modalSubclasses.hide()
    }
  },
  computed: {
    timeRangeList () {
      let res = []
      for (let el of this.$store.getters['Tariffing/TIME_RANGES']) {
        let newEl = {}
        newEl.value = el.tr_id
        newEl.text = el.name + ' (' + el.tr_id + ')'
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('Not defined')})
      return res
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/other/trafficClasses/editModal.vue